/**
 * Which spacecraft the HUD reports on (telemetry): the followed one, else the focused one, else the selected
 * mission's, else the most recently launched one that is in flight at the current date. The caller checks the
 * candidates in order (`isShown`), because with a fleet the first spacecraft in the data may not have launched yet.
 */
import type { FocusTarget } from '../app';

export function spacecraftCandidates(
  targets: Map<string, FocusTarget>,
  followId: string | null,
  focusId: string,
  selectedMission: string | null = null,
): string[] {
  const out: string[] = [];
  const add = (id: string | null | undefined): void => {
    if (id && targets.get(id)?.kind === 'spacecraft' && !out.includes(id)) out.push(id);
  };
  add(followId);
  add(focusId);
  const fleet = [...targets.values()].filter((t) => t.kind === 'spacecraft');
  for (const t of fleet) if (selectedMission && t.mission === selectedMission) add(t.id);
  for (const t of fleet.sort((a, b) => (b.launch ?? 0) - (a.launch ?? 0))) add(t.id);
  return out;
}

/** The first candidate that is shown right now, or null. */
export function activeSpacecraftId(candidates: readonly string[], isShown: (id: string) => boolean): string | null {
  for (const id of candidates) if (isShown(id)) return id;
  return null;
}
